import { errorByCode } from "./errors";
import { auth, db } from "./app";

const SIGNUP_SAFE_PAYLOAD_ATTRS = [
  "gender",
  "lastname",
  "firstname",
  "company",
  "activity",
  "address",
  "city",
  "postalCode",
  "country",
  "email",
];

const userSafePayload = payload => {
  return SIGNUP_SAFE_PAYLOAD_ATTRS.reduce((acc, attr) => {
    acc[attr] = payload[attr] || "";
    return acc;
  }, {});
};

export function* signup(payload = {}) {
  let error;

  try {
    const { email = "", password = "" } = payload;
    const safePayload = userSafePayload(payload);
    const { user } = yield auth.createUserWithEmailAndPassword(email, password);

    yield db
      .collection("users")
      .doc(user.uid)
      .set({
        createdAt: Date.now(),
        ...safePayload
      });
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export function* signin(payload) {
  let error;

  try {
    const { email = "", password = "" } = payload;

    yield auth.signInWithEmailAndPassword(email, password);
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export function* securitySignin(payload) {
  let error;
  const { email = "", password = "" } = payload;
  const user = auth.currentUser;

  try {
    yield user.reauthenticateAndRetrieveDataWithCredential(email, password);
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export function* resetPassword(payload) {
  let error;

  const { email = "" } = payload;

  try {
    yield auth.sendPasswordResetEmail(email);
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export function* signout() {
  yield auth.signOut();
}

export function onChange(hanlder) {
  return auth.onAuthStateChanged(user => hanlder(user));
}



// WEBPACK FOOTER //
// ./src/services/firebase/auth.js